<template>
  <v-card>
    <v-tabs :value="voyageTabtest">
      <v-tabs-slider color="primary"></v-tabs-slider>
      <v-tab @click="fetchVoyages()">Voyages</v-tab>
      <v-tab v-show="displayVoyageReviewTab" @click="reviewVesselVoyage()">Voyage Information</v-tab>
      <v-tab-item>
        <transition name="slide-x-transition" mode="out-in">
          <router-view :key="routeKey"></router-view>
        </transition>
      </v-tab-item>
      <v-tab-item v-if="displayVoyageReviewTab">
        <transition name="slide-x-transition" mode="out-in">
          <router-view :key="routeKey"></router-view>
        </transition>
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>

<script>
import { VESSEL_VOYAGE_TABMENU } from '@/store/types'

export default {
  data() {
    return {
    }
  },
  computed: {
    voyageTabtest() {
      return this.$store.state.vessel.voyage.vslVoyageTabMenu
    },
    displayVoyageReviewTab() {
      return this.$store.state.vessel.voyage.vslVoyageDisplayVoyageReviewTab
    },
    routeKey() {
      if (this.$route.matched && this.$route.matched.length > 0) {
        // This is to solve the route loading fail for pages with same component
        // Eg: SubRoute - Vue JS will reuse same component for same route level, thus not triggering the lifeCycle methods
        // Note: this will only solve the problem for index 0 route
        return this.$route.matched[0].name
      }
      return ''
    }
  },
  methods: {
    fetchVoyages() {
      const commitData = {
        voyageTab: 0,
        displayVoyageReviewTab: false
      }
      this.$store.commit(VESSEL_VOYAGE_TABMENU, commitData)
      this.$router.push({ name: 'vesselVoyages', params: { vesNo: this.vesNo } })
    },
    reviewVesselVoyage() {
      const commitData = {
        voyageTab: 1,
        displayVoyageReviewTab: true
      }
      this.$store.commit(VESSEL_VOYAGE_TABMENU, commitData)
      this.$router.push({ name: 'voyageReview', params: { voyNo: this.voyNo } })
    }
  },
  props: {
    vesNo: {
      type: String,
      default: ''
    }
  },
  created() {
    this.fetchVoyages()
  }
}
</script>

<style lang="scss">
</style>
